<template>
  <!--begin::Project Listing-->
  <ListingTemplate :customClass="'timesheet-listing'">
    <template v-slot:body>
      <ListingHeader>
        <template v-slot:content>
          <template v-if="selectedRows?.length > 0">
            <v-col cols="4" class="pt-0">
              <h1 class="form-title d-flex margin-auto selected-rows-text">
                {{ totalSelected }} Selected
              </h1>
            </v-col>
            <v-col cols="8" class="pt-0 justify-flex-end d-flex margin-auto">
              <template v-if="getPermission('project:update')">
                <v-menu
                  content-class="custom-menu-list"
                  bottom
                  offset-y
                  transition="slide-y-transition"
                  :close-on-click="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-grey-border custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                    </v-btn>
                  </template>
                  <v-list>
                    <template v-for="(more, index) in projectMoreAction">
                      <v-list-item
                        link
                        v-on:click="updateMoreAction(more.action)"
                        :key="index"
                      >
                        <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                          <v-icon class="icon-default-blue">{{
                            more.icon
                          }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          class="font-weight-500 font-size-14"
                          >{{ more.title }}</v-list-item-title
                        >
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </template>
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red lighten-1 white--text"
                v-on:click="clearSelections"
              >
                <v-icon dark left>mdi-close</v-icon>Clear Selections
              </v-btn>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="12" class="pa-0 col-md-12 col-lg-5 my-auto">
              <div
                class="d-inline-flex align-items-center timesheet-kpi-summary"
              >
                <v-avatar size="36" color="cyan lighten-4" class="mr-3">
                  <v-icon color="cyan">mdi-clock-time-four-outline</v-icon>
                </v-avatar>
                <div class="d-flex align-items-center font-size-15">
                  <span
                    class="grey--text text--darken-1 font-weight-600 text-uppercase letter-spacing-1 pr-2"
                  >
                    Total Hours:
                  </span>
                  <span class="font-weight-700 red--text text--darken-2">
                    {{ totalAmount(rowData) }}
                  </span>
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              class="pa-0 col-md-12 col-lg-7 justify-flex-end d-flex margin-auto all-project-btn-right"
            >
              <v-flex
                md="2"
                class="pb-0 mr-2 d-flex align-items-center"
                style="max-width: 100% !important"
              >
                <label for="" class="font-weight-600 mb-0 mr-2">
                  Filter By
                </label>
                <v-autocomplete
                  hide-details
                  clearable
                  v-model.trim="filter_engineer"
                  :items="engineerList"
                  dense
                  flat
                  filled
                  label="Technician"
                  item-color="cyan"
                  color="cyan"
                  class="mr-2"
                  solo
                  v-on:click:clear="clearFilter('engineer')"
                  :disabled="pageLoading || engineerLoading"
                  :loading="engineerLoading || pageLoading"
                  item-text="display_name"
                  item-value="id"
                  v-on:change="getRows"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title
                        v-html="'No Technician(s) Found.'"
                      ></v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar
                      height="30"
                      min-width="30"
                      width="30"
                      class="mr-1 my-1 grey lighten-2 grey--text"
                    >
                      <v-img
                        v-if="item.profile_logo != null"
                        src="item.profile_logo"
                      ></v-img>
                      <span v-else class="fw-600 mb-1">{{
                        item.display_name.slice(0, 2).toUpperCase()
                      }}</span>
                    </v-list-item-avatar>
                    <v-list-item-content class="text-ellipsis max-width-400px">
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                        >{{ item.display_name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action
                      class="align-self-center"
                      v-if="filter_engineer == item.user"
                    >
                      <v-icon color="cyan">mdi-check</v-icon>
                    </v-list-item-action>
                  </template>
                </v-autocomplete>
                <v-menu
                  v-model="datePicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      filled
                      flat
                      label="Date Range"
                      hide-details
                      solo
                      :loading="pageLoading"
                      :disabled="pageLoading"
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-on:click:clear="clearFilter('dates')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :value="formattedDate"
                      color="cyan"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="cyan"
                    range
                    :disabled="pageLoading"
                    v-on:change="getRows"
                    v-model="dates"
                    :month-picker="true"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-bold-button"
                color="cyan white--text"
                v-on:click="exportTimesheet"
              >
                <v-icon dark left>mdi-database-export</v-icon> Export
              </v-btn>
              <v-menu
                max-height="400"
                max-width="250"
                left
                offset-y
                :close-on-content-click="false"
                content-class="white-background"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button btn-tab-hide"
                    color="cyan white--text"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-table-edit</v-icon>
                  </v-btn>
                </template>
                <draggable
                  tag="ul"
                  v-model="defaultColDefs"
                  class="draggable-group"
                  handle=".draggable-drag-icon"
                  v-on:change="handleChange"
                >
                  <template v-for="cols in defaultColDefs">
                    <li
                      class="draggable-group-item"
                      :key="cols.field"
                      v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                    >
                      <v-checkbox
                        dense
                        v-model="defaultColShow"
                        v-bind:value="cols.field"
                        :label="cols.headerName"
                        :disabled="
                          (Number(cols.fixed) > 0 ? true : false) || dataLoading
                        "
                        color="cyan"
                        hide-details
                        class="mt-0 mb-0"
                        v-on:change="handleChange"
                      ></v-checkbox>
                      <v-icon class="draggable-drag-icon" right color="cyan"
                        >mdi-drag</v-icon
                      >
                    </li>
                  </template>
                </draggable>
              </v-menu>
            </v-col>
          </template>
        </template>
      </ListingHeader>
      <ListingSearchCriteria
        v-if="searchEnabled"
        pageModule="Technician"
        :basicSearchFields="['barcode', 'display name']"
        :allowedSearchFields="searchableArray"
      ></ListingSearchCriteria>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <ListingTable
          :columnCount="columnLength()"
          :dataLoading="dataLoading"
          :rowData="rowData"
        >
          <template v-slot:thead>
            <thead>
              <tr>
                <template v-for="cols in customThead">
                  <th
                    v-if="cols.visible"
                    :key="cols.id"
                    class="simple-table-th"
                    :class="{
                      'checkbox-width-limit': cols.checkbox,
                      'pointer-events-none': lodash.isEmpty(rowData),
                    }"
                  >
                    <template
                      v-if="cols.checkbox && Number(cols.checkbox) == 1"
                    >
                      <v-checkbox
                        dense
                        :disabled="dataLoading"
                        v-model="selectedAll"
                        color="cyan"
                        class="hide-margin"
                        hide-details
                      ></v-checkbox>
                    </template>
                    <template v-else>
                      <div
                        v-if="cols.sortable"
                        class="simple-table-text sortable"
                        v-on:click="
                          !dataLoading
                            ? updateSorting({
                                field: cols.field,
                                sort: cols.sort,
                              })
                            : 'javascript:void(0)'
                        "
                      >
                        {{ cols.headerName }}
                      </div>
                      <div v-else class="simple-table-text">
                        {{ cols.headerName }}
                      </div>
                      <template v-if="cols.sort">
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'asc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-ascending</v-icon
                        >
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'desc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-descending</v-icon
                        >
                      </template>
                    </template>
                  </th>
                </template>
              </tr>
            </thead>
          </template>
          <template v-slot:tbody>
            <tbody class="custom-border-bottom">
              <template v-if="!lodash.isEmpty(rowData)">
                <template v-for="(data, rowIndex) in rowData">
                  <!-- class="timesheet-row-group-new" -->
                  <tr
                    class="timesheet-listing-row service-listing-row"
                    :key="'main-row-' + rowIndex"
                    @mouseenter="hoveredRowIndex = rowIndex"
                    @mouseleave="hoveredRowIndex = null"
                    :class="{
                      'row-hover-active': hoveredRowIndex === rowIndex,
                    }"
                  >
                    <template v-for="(cols, colIndex) in customThead">
                      <td
                        v-if="cols.visible && !isBreakColumn(cols.field)"
                        :key="'col-' + rowIndex + '-' + colIndex"
                        :rowspan="getBreakLength(data)"
                        :class="{
                          'simple-table-td': !cols.checkbox,
                          'checkbox-width-limit': cols.checkbox,
                        }"
                      >
                        <template
                          v-if="cols.checkbox && Number(cols.checkbox) == 1"
                        >
                          <v-checkbox
                            dense
                            v-model="selectedRows"
                            :value="data?.id"
                            color="cyan"
                            class="hide-margin"
                            hide-details
                          />
                        </template>

                        <template v-else-if="cols.field == 'engineer_barcode'">
                          <Barcode
                            v-if="data?.engineer?.barcode"
                            :id="data?.engineer?.id"
                            :barcode="data?.engineer?.barcode"
                            route="engineer.detail"
                          />
                        </template>

                        <template v-else-if="cols.field == 'datetime'">
                          {{ formatDate(data.checkin_time) }}
                        </template>

                        <template v-else-if="cols.field == 'user_id'">
                          <div
                            class="engineer-listing d-flex align-items-center"
                          >
                            <v-avatar
                              size="34"
                              class="mr-2 grey lighten-2 font-weight-600 cyan--text text--darken-2 flex-shrink-0"
                            >
                              <v-img
                                v-if="data?.engineer?.profile_logo"
                                :src="$assetAPIURL(data.engineer.profile_logo)"
                              ></v-img>
                              <v-icon v-else color="cyan darken-2" small
                                >mdi-account</v-icon
                              >
                            </v-avatar>
                            <div>
                              <p
                                class="m-0 font-weight-600 font-size-13 text-capitalize color-3f4254 text-truncate max-width-180px"
                              >
                                {{ data?.engineer?.display_name || "N/A" }}
                              </p>
                              <div class="mt-0">
                                <v-chip
                                  v-if="data?.engineer?.designation?.text"
                                  x-small
                                  color="red lighten-5"
                                  text-color="red darken-2"
                                  class="font-weight-500"
                                  label
                                >
                                  {{ data.engineer.designation.text }}
                                </v-chip>
                                <span
                                  v-else
                                  class="text-caption text-muted font-italic"
                                  >no designation</span
                                >
                              </div>
                            </div>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'checkin_date'">
                          <div class="contract-listing-customer">
                            <p class="ma-0 custom-nowrap-ellipsis-count">
                              <b>{{ formatDateCustom(data.checkin_time) }}</b>
                            </p>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'checkin_time'">
                          <div class="contract-listing-customer">
                            <p class="ma-0 custom-nowrap-ellipsis-count">
                              <v-chip
                                small
                                v-if="data?.checkin_time"
                                color="green"
                                outlined
                                label
                              >
                                {{ formatTimeCustom(data.checkin_time) }}
                              </v-chip>
                            </p>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'checkout_date'">
                          <div class="contract-listing-customer">
                            <p class="ma-0 custom-nowrap-ellipsis-count">
                              <b>{{ formatDateCustom(data.checkout_time) }}</b>
                            </p>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'checkout_time'">
                          <div class="project-listing-project">
                            <v-chip
                              v-if="data?.checkout_time"
                              small
                              color="red"
                              outlined
                              label
                            >
                              {{ formatTimeCustom(data.checkout_time) }}
                            </v-chip>
                            <b v-else> -- </b>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'total_time'">
                          <div class="project-listing-status">
                            <v-chip
                              small
                              v-if="data?.total_time"
                              color="blue"
                              outlined
                              label
                            >
                              {{ formatTime(data.total_time) }}
                            </v-chip>
                            <b v-else> -- </b>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'total_break_time'">
                          <div class="project-listing-status">
                            <v-chip
                              small
                              v-if="
                                data?.break_relation?.length &&
                                getTotalBreakTime(data.break_relation)
                              "
                              color="blue"
                              outlined
                              label
                            >
                              {{ getTotalBreakTime(data.break_relation) }}
                            </v-chip>
                            <b v-else> -- </b>
                          </div>
                        </template>

                        <template
                          v-else-if="cols.field == 'total_working_hours'"
                        >
                          <div class="project-listing-status">
                            <v-chip
                              small
                              v-if="getWorkingTime(data)"
                              color="blue"
                              outlined
                              label
                            >
                              {{ getWorkingTime(data) }}
                            </v-chip>
                            <b v-else> -- </b>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'location'">
                          <div
                            class="d-flex align-items-center max-width-220px"
                          >
                            <v-icon
                              small
                              color="grey darken-1"
                              class="mr-1 flex-shrink-0"
                              >mdi-map-marker-outline</v-icon
                            >
                            <v-tooltip top v-if="data.address">
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  class="text-truncate font-size-13 text-capitalize color-3f4254"
                                >
                                  {{ data.address }}
                                </span>
                              </template>
                              <span>{{ data.address }}</span>
                            </v-tooltip>
                            <em v-else class="text-muted font-size-13"
                              >no location</em
                            >
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'device_info'">
                          <div class="device-info-cell font-size-12">
                            <div
                              class="d-flex align-items-center mb-0 text-truncate"
                              :title="data.ipAddress || 'No IP address'"
                            >
                              <v-icon
                                x-small
                                color="cyan"
                                class="mr-1 flex-shrink-0"
                                >mdi-ip-network-outline</v-icon
                              >
                              <span
                                class="font-weight-600 mr-1 grey--text text--darken-2"
                                >IP:</span
                              >
                              <span class="text-truncate">{{
                                data.ipAddress || "N/A"
                              }}</span>
                            </div>
                            <div
                              class="d-flex align-items-center mb-0 text-truncate"
                              :title="data.in_device || 'No device'"
                            >
                              <v-icon
                                x-small
                                color="cyan"
                                class="mr-1 flex-shrink-0"
                                >mdi-cellphone-link</v-icon
                              >
                              <span
                                class="font-weight-600 mr-1 grey--text text--darken-2"
                                >Device:</span
                              >
                              <span class="text-truncate">{{
                                data.in_device || "N/A"
                              }}</span>
                            </div>
                            <div
                              class="d-flex align-items-center text-truncate"
                              :title="data.in_platform || 'No Platform'"
                            >
                              <v-icon
                                x-small
                                color="cyan"
                                class="mr-1 flex-shrink-0"
                                >mdi-laptop</v-icon
                              >
                              <span
                                class="font-weight-600 mr-1 grey--text text--darken-2"
                                >OS:</span
                              >
                              <span class="text-truncate">{{
                                data.in_platform || "N/A"
                              }}</span>
                            </div>
                          </div>
                        </template>
                      </td>

                      <td
                        v-else-if="cols.field == 'break_check_in_time'"
                        :key="'break-in-' + rowIndex + '-' + colIndex"
                      >
                        <template v-if="data?.break_relation?.length">
                          <v-chip
                            v-if="data.break_relation[0]?.checkin_time"
                            small
                            color="green"
                            outlined
                            label
                          >
                            {{
                              formatTimeCustom(
                                data.break_relation[0].checkin_time
                              )
                            }}
                          </v-chip>
                          <b v-else> -- </b>
                        </template>
                        <b v-else> -- </b>
                      </td>

                      <td
                        v-else-if="cols.field == 'break_check_out_time'"
                        :key="'break-out-' + rowIndex + '-' + colIndex"
                      >
                        <template v-if="data?.break_relation?.length">
                          <v-chip
                            v-if="data.break_relation[0]?.checkout_time"
                            small
                            color="red"
                            outlined
                            label
                          >
                            {{
                              formatTimeCustom(
                                data.break_relation[0].checkout_time
                              )
                            }}
                          </v-chip>
                          <b v-else> -- </b>
                        </template>
                        <b v-else> -- </b>
                      </td>
                    </template>
                  </tr>

                  <tr
                    v-for="(item, breakIndex) in getExtraBreaks(data)"
                    :key="'break-row-' + rowIndex + '-' + breakIndex"
                    @mouseenter="hoveredRowIndex = rowIndex"
                    @mouseleave="hoveredRowIndex = null"
                    :class="{
                      'row-hover-active': hoveredRowIndex === rowIndex,
                    }"
                  >
                    <td :key="'break-in-extra-' + rowIndex + '-' + breakIndex">
                      <v-chip
                        v-if="item.checkin_time"
                        small
                        color="green"
                        outlined
                        label
                      >
                        {{ formatTimeCustom(item.checkin_time) }}
                      </v-chip>
                      <b v-else> -- </b>
                    </td>

                    <td :key="'break-out-extra-' + rowIndex + '-' + breakIndex">
                      <v-chip
                        v-if="item.checkout_time"
                        small
                        color="red"
                        outlined
                        label
                      >
                        {{ formatTimeCustom(item.checkout_time) }}
                      </v-chip>
                      <b v-else> -- </b>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-else-if="!dataLoading">
                <td colspan="100%" class="py-4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no timesheet at the moment.
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </ListingTable>
      </perfect-scrollbar>
      <ListingFooter
        :dataLoading="dataLoading"
        :showingFrom="showingFrom"
        :showingTo="showingTo"
        :totalRows="totalRows"
        :currentPage="currentPage"
        :totalPages="totalPages"
      ></ListingFooter>
      <Dialog :commonDialog="searchDialog">
        <template v-slot:title>Filter Project</template>
        <template v-slot:body>
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll custom-box-top-inner-shadow"
            style="max-height: 90vh; position: relative"
          >
            <v-container fluid class="pt-0 custom-search-filter">
              <v-row>
                <template v-for="(field, index) in searchableArray">
                  <v-col md="6" :key="index" v-if="field != 'dates'">
                    <v-text-field
                      v-model.trim="listingSearch[field]"
                      dense
                      filled
                      hide-details
                      :label="getFilterLabel(field, 'Project')"
                      solo
                      flat
                      clearable
                      @keydown.enter="filterRows"
                      color="cyan"
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </perfect-scrollbar>
        </template>
        <template v-slot:action>
          <v-btn
            :disabled="dataLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            color="cyan white--text"
            v-on:click="filterRows"
          >
            Filter
          </v-btn>
          <v-btn
            :disabled="dataLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="searchDialog = false"
          >
            Close
          </v-btn>
        </template>
      </Dialog>
      <template v-if="customerDialog">
        <CustomerDialog
          :customerDialog="customerDialog"
          v-on:closeDialog="customerDialog = false"
          v-on:resetAll="customerDialog = false"
          v-on:selectCustomer="selectCustomer"
        ></CustomerDialog>
      </template>
      <template v-if="customerPropertyDialog">
        <CustomerPropertyDialog
          disabled-auto-select
          :customerPropertyDialog="customerPropertyDialog"
          :customer="customer"
          v-on:closeDialog="closeDialog"
          v-on:resetAll="resetAll"
          v-on:selectCustomerProperty="selectCustomerProperty"
        ></CustomerPropertyDialog>
      </template>
    </template>
  </ListingTemplate>

  <!--end::Project Listing-->
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import JwtService from "@/core/services/jwt.service";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
/* import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue" */ import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
import CustomerPropertyDialog from "@/view/pages/partials/Select-Customer-Property.vue";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import moment from "moment-timezone";

export default {
  mixins: [CommonMixin, ListingMixin],
  name: "timesheet-list",
  data() {
    return {
      hoveredRowIndex: null,
      pageTips: false,
      customerDialog: false,
      engineerList: [],
      customerPropertyDialog: false,
      exportLoading: false,
      pageModule: "timesheet-listing",
      routeAPI: "timesheet",
      routeName: "profile.timeSheet",
      status: "all",
      engineerLoading: false,
      pageLoading: false,
      file: "",
      importDialog: false,
      statusList: [],
      customThead: [],
      moreActions: [
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      projectMoreAction: [
        {
          title: "Mark as Finished",
          action: "mark_as_finish",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Cancelled",
          action: "mark_as_cancel",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Hold",
          action: "mark_as_hold",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as In-Progress",
          action: "mark_as_inprogress",
          icon: "mdi-check-all",
        },
      ],
    };
  },
  components: {
    draggable,
    CustomerDialog,
    CustomerPropertyDialog,
    /*   PageHeaderCount, */
    Barcode,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
  },

  methods: {
    isBreakColumn(field) {
      return ["break_check_in_time", "break_check_out_time"].includes(field);
    },

    getBreakLength(data) {
      return data?.break_relation?.length ? data.break_relation.length : 1;
    },

    getExtraBreaks(data) {
      return data?.break_relation?.slice(1) || [];
    },
    handleChange() {
      this.$nextTick(() => {
        this.updateVisible();
      });
    },

    getTotalBreakSeconds(breaks) {
      if (!breaks || !breaks.length) return 0;

      return breaks.reduce((sum, item) => {
        return sum + Number(item.total_time || 0);
      }, 0);
    },

    getWorkingTime(data) {
      if (!data || !data.total_time) return "";

      const totalSeconds = Number(data.total_time);

      const breakSeconds = this.getTotalBreakSeconds(data.break_relation);

      const workingSeconds = totalSeconds - breakSeconds;

      if (workingSeconds <= 0) return "";

      return this.formatTime(workingSeconds);
    },

    getTotalBreakTime(breaks) {
      if (!breaks || !breaks.length) return "";

      const totalSeconds = breaks.reduce((sum, item) => {
        return sum + Number(item.total_time || 0);
      }, 0);

      if (!totalSeconds) return "";

      const hrs = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      let result = [];

      if (hrs) result.push(`${hrs} hour${hrs > 1 ? "s" : ""}`);
      if (mins) result.push(`${mins} minute${mins > 1 ? "s" : ""}`);
      if (secs) result.push(`${secs} second${secs > 1 ? "s" : ""}`);

      return result.join(" ");
    },

    formatTime(seconds) {
      if (!seconds) return "--";

      seconds = Number(seconds);

      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      let result = [];

      if (hrs) result.push(`${hrs} hour${hrs > 1 ? "s" : ""}`);
      if (mins) result.push(`${mins} minute${mins > 1 ? "s" : ""}`);
      if (secs) result.push(`${secs} second${secs > 1 ? "s" : ""}`);

      return result.join(" ");
    },

    exportTimesheet() {
      const { query } = this.$route;

      let downloadURL = process.env.VUE_APP_API_URL + "timesheet/export";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      if (query) {
        this.lodash.map(query, (row, index) => {
          if (row) {
            downloadURL.searchParams.append(`${index}`, row);
          }
        });
      }
      if (this.dates && this.dates[0] && this.dates[1]) {
        if (this.dates && this.dates[0]) {
          downloadURL.searchParams.append("daterange[0]", this.dates[0]);
        }
        if (this.dates && this.dates[1]) {
          downloadURL.searchParams.append("daterange[1]", this.dates[1]);
        }
      }
      if (this.filter_engineer) {
        downloadURL.searchParams.append(
          "filter_engineer",
          this.filter_engineer
        );
      }

      window.open(downloadURL, "_blank");
    },

    totalAmount(data) {
      let result = this.lodash.reduce(
        data,
        (acc, row) => {
          acc =
            this.lodash.toNumber(acc) + this.lodash.toNumber(row.total_time);
          return acc;
        },
        0
      );

      const hours = Math.floor(result / 3600);
      const minutes = Math.floor((result % 3600) / 60);
      const remainingSeconds = result % 60;
      let totalTime = `${hours} hours, ${minutes} minutes, ${remainingSeconds} seconds`;

      return totalTime;
    },
    formatTimeCustom(date) {
      if (date) {
        let dateFormated = moment(date).format("hh:mm:ss A");
        return dateFormated;
      } else {
        return "--";
      }
    },
    formatDateCustom(date) {
      if (date) {
        let dateFormated = moment(date).format("dddd, MMM Do YYYY");
        return dateFormated;
      } else {
        return "--";
      }
    },

    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "engineer":
          _this.filter_engineer = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getRows();
    },

    getEngineers() {
      const _this = this;
      _this.engineerLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "engineer-list",
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              _this.engineerLoading = false;
              reject(error);
            })
            .finally(() => {
              _this.engineerLoading = false;
            });
        } catch (error) {
          _this.logError(error);
          _this.engineerLoading = false;
          reject(error);
        }
      });
    },
    getEngineerList() {
      const _this = this;

      _this
        .getEngineers()
        .then((engineer) => {
          _this.engineerList = engineer;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
  },
  created() {
    if (this.$route?.query?.id) {
      this.filter_engineer = this.lodash.toSafeInteger(this.$route?.query?.id);
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Timesheet",
      },
    ]);
    this.getEngineerList();
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
<style scoped>
.main-listing-page {
  border-top: 0 !important;
}

.row-hover-active td {
  background-color: #f7f9fa !important;
  transition: background-color 0.2s ease;
}

.timesheet-kpi-summary {
  background-color: #f4f8fb;
  border-radius: 8px;
  padding: 3px 14px;
  border: 1px solid #e0f2f1;
}
.color-3f4254 {
  color: #3f4254 !important;
}

.letter-spacing-1 {
  letter-spacing: 0.5px;
}

.max-width-180px {
  max-width: 180px;
}

.max-width-220px {
  max-width: 220px;
}
</style>
